var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#337FFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3447 21.1068L24.863 17.6942H21.621V15.4806C21.621 14.5467 22.0731 13.6359 23.5251 13.6359H25V10.7306C25 10.7306 23.6621 10.5 22.3836 10.5C19.7123 10.5 17.968 12.1348 17.968 15.0932V17.6942H15V21.1068H17.968V29.357C18.5639 29.4516 19.1735 29.5 19.7945 29.5C20.4155 29.5 21.0251 29.4516 21.621 29.357V21.1068H24.3447Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.9fcacab31be8e73322114da633ada64b.svg";
export { ForwardRef as ReactComponent };